import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface OcraLocationViewModel {
  LocationId: string;
  LocationName: string;
  LocationDisplayName: string;
}

@Injectable({ providedIn: 'root' })
export class OcraService {
  constructor(private _httpClient: HttpClient) {}

  // Get all locations
  getLocations(): Observable<any> {
    return this._httpClient.get<any>('Ocra/Location');
  }

  // Get location enabled
  getEnabled(): Observable<boolean> {
    return this._httpClient.get<boolean>('Ocra/Enabled');
  }
}
